import { useMemo } from 'react';
import toast from 'react-hot-toast';
import { FormDialog, RhfSelect } from '@core/components';
import { getOptions } from '@core/utils/enum';
import { type Order, releaseOrder } from '../../api/order';
import { ReleaseType } from '../enum/releaseType';

interface ReleaseOrderDialogProps {
  open: boolean;
  onClose: () => void;
  order: Order | null;
  onSuccess?: () => void;
}

type ReleaseOrderFormValues = {
  releaseType: ReleaseType | '';
};

const ReleaseOrderDialog = ({
  open,
  onClose,
  order,
  onSuccess,
}: ReleaseOrderDialogProps) => {
  const defaultValues = useMemo<ReleaseOrderFormValues>(
    () => ({
      releaseType: '',
    }),
    []
  );

  const onSubmit = async (data: ReleaseOrderFormValues) => {
    if (!order || !data.releaseType) return;
    await releaseOrder(order.id, data.releaseType);
    toast.success('Order released');
    onSuccess?.();
  };

  return (
    <FormDialog<ReleaseOrderFormValues>
      open={open}
      onClose={onClose}
      title="Release order"
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      submitText="Release"
      cancelText="Cancel"
    >
      <RhfSelect<ReleaseOrderFormValues>
        name="releaseType"
        label="Type"
        required
        options={getOptions(ReleaseType)}
      />
    </FormDialog>
  );
};

export default ReleaseOrderDialog;
